import React, { useEffect, useState } from "react";
import CVGeneratorForm from "./cv-generator";
import CVReview from "./cv-review";
import { useSelector } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";

const CVGenerator = () => {
  const [showCv, setShowCv] = useState(false);
  const [userCvData, setUserCvData] = useState(null);

  const toggleCV = () => {
    setShowCv(!showCv);
    if (!!showCv) {
      setUserCvData(null);
    }
  };
  const siteSettings = useSelector(
    (state) => state.fetchSiteSettings.siteSettings
  );
  useDocumentTitle(
    siteSettings?.site_name
      ? "Smart CV Generator - " + siteSettings?.site_name
      : "UK Visa Jobs"
  );
  return (
    <>
      {showCv ? (
        <CVReview
          toggleCV={toggleCV}
          cvData={
            userCvData?.cv_details ? JSON.parse(userCvData?.cv_details) : null
          }
          cv_id={userCvData?.id}
        />
      ) : (
        <CVGeneratorForm
          toggleCV={toggleCV}
          setUserCvData={setUserCvData}
          siteSettings={siteSettings}
        />
      )}
    </>
  );
};

export default CVGenerator;
